import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';
import { useProperties } from '@/hooks/use-property-queries';
import { usePermissions } from '@/hooks/use-permissions';
import { PageLoader } from '@/components/page-loader';
import { PERMISSIONS } from '@property/shared';

export const Route = createFileRoute('/dashboard/')({
  component: DashboardOverview,
});

function DashboardOverview() {
  const { data: properties, isLoading, isFetching, isStale, isError } = useProperties();
  const { can, role, isLoading: permissionsLoading } = usePermissions();
  const navigate = useNavigate();
  const redirected = useRef(false);

  useEffect(() => {
    if (redirected.current || permissionsLoading || isLoading || isFetching || isStale) return;

    redirected.current = true;

    if (!isError && role === 'user' && properties?.length === 0) {
      navigate({ to: '/dashboard/land-monitoring/add-property' });
    } else if (can(PERMISSIONS.TASKS_READ)) {
      navigate({ to: '/dashboard/tasks' });
    } else if (can(PERMISSIONS.INSPECTIONS_REVIEW)) {
      navigate({ to: '/dashboard/reviews' });
    } else if (can(PERMISSIONS.PROPERTIES_READ)) {
      navigate({ to: '/dashboard/land-monitoring' });
    } else if (can(PERMISSIONS.ROLES_ASSIGN)) {
      navigate({ to: '/dashboard/users' });
    }
  }, [
    permissionsLoading,
    isLoading,
    isFetching,
    isStale,
    isError,
    role,
    properties,
    navigate,
    can,
  ]);

  return <PageLoader />;
}
